<template>
  <div>
    <div>
      <loading-component v-if="userLoadingFlag"></loading-component>
    </div>
    <section class="common2-wrap">
      <a class="common2_open"></a>
    </section>
    <!-- 업데이트 모달-->
    <section class="common2-modal" id="common2">
      <div class="alert">
        최신 업데이트가 있습니다. <br />
        업데이트 후 다시 실행해주세요.<br /><br />

        확인 클릭 후 <br />
        업데이트가 아니라 열기로 표시될 경우<br /><br />
        google playstore에서 "이지스 펜차트" <br />
        검색 하시면 업데이트로 표시됩니다.<br />
      </div>
      <div class="btn-group">
        <a @click="updateStore('R')" class="btn-common2 common2_close">확인</a>
      </div>
    </section>
    <JqueryPopup />
  </div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script>
import Cookies from 'js-cookie';
import JqueryPopup from '../../components/jquery/JqueryPopup.vue';
import Loading from '../../components/loading/Loading.vue';
import axios from 'axios';

export default {
  components: {
    JqueryPopup,
    'loading-component': Loading
  },
  data() {
    return {
      userLoadingFlag: false,
      cookieUserId: '',
      cookieAutoLogin: '',
      cookieUserPw: '',
      versionItems: [{}]
    };
  },
  created: function () {
    this.userLoadingFlag = true;
  },
  mounted: function () {
    // var dbVersion = '1.1.0';
    // var appVersion = '0.9.7';
    // if (this.compareVersion(dbVersion, appVersion)) {
    // 	alert('업데이트');
    // } else {
    // 	alert('정상');
    // }
    if ($('#common2_wrapper').length > 0) $('#common2_wrapper').remove();
    $('#common2').popup({
      transition: 'all 0.3s',
      blur: false,
      escape: true,
      scrolllock: true,
      closebutton: false,
      background: true
    });
    window.receiveDeviceInfo = this.receiveDeviceInfo;
    window.receiveOption = this.receiveOption;

    // 로컬 개발일 경우
    if (this.$store.state.serverType === '1') {
      this.$axios.defaults.baseURL = `${this.$store.state.apiDomain}`;
      this.$router.push({
        name: '로그인'
      });
    }
    //배포일 경우
    else {
      this.callDeviceInfo();
      this.getOption();
    }
  },
  methods: {
    async getOption() {
      try {
        if (this.$osType === 'android') {
          window.penchart.getOption();
        } else if (this.$osType === 'ios') {
          window.webkit.messageHandlers.getOption.postMessage('');
        }
      } catch (e) {
        alert(e);
      }
    },
    async receiveOption(json) {
      try {
        if (json != null) {
          this.$store.commit('settingInfo', json);
          if (this.$osType === 'web' || this.$osType === 'ios') {
            this.$util.setOption(json);
          } else {
            this.$util.setOption(JSON.stringify(json));
          }
        }
      } catch (e) {
        alert(`receiveOption 에러 ${e}`);
      }
    },
    async autoLogin() {
      try {
        let url = `/login`;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          await this.$axios
            .post(url, {
              loginInfo: this.cookieUserPw
            })
            .then((response) => {
              if (response.data.state == 'success') {
                //자동로그인시 쿠키 유효기간 7일 연장.
                let d = new Date();
                d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
                let expires = 'expires=' + d.toUTCString();
                document.cookie = 'cookieUserId=' + this.cookieUserId + ';' + expires + ';path=/';
                document.cookie = 'cookieUserPw=' + this.cookieUserPw + ';' + expires + ';path=/';
                document.cookie = 'cookieAutoLogin=Y;' + expires + ';path=/';

                this.$store.commit('login', response.data.data);
                this.$router.push({
                  name: '대기리스트'
                });
              } else {
                this.$router.push({
                  name: '로그인'
                });
              }
            })
            .catch((e) => {
              alert('Agent 연결 실패', e);
              console.log(e);
            });
        } else {
          let apiPostData = JSON.stringify({
            url: `${this.$store.state.apiDomain}/login`,
            param: {
              loginInfo: this.cookieUserPw
            }
          });
          let result = await this.$util.postApi(apiPostData);
          if (result.state == 'success') {
            //자동로그인시 쿠키 유효기간 7일 연장.
            let d = new Date();
            d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
            let expires = 'expires=' + d.toUTCString();
            document.cookie = 'cookieUserId=' + this.cookieUserId + ';' + expires + ';path=/';
            document.cookie = 'cookieUserPw=' + this.cookieUserPw + ';' + expires + ';path=/';
            document.cookie = 'cookieAutoLogin=Y;' + expires + ';path=/';

            this.$store.commit('login', result.data);
            this.$router.push({
              name: '대기리스트'
            });
          } else {
            this.$router.push({
              name: '로그인'
            });
          }
        }
      } catch (e) {
        //alert(`auto login error=${e}`);
        this.$router.push({
          name: '로그인'
        });
      }
    },
    //디바이스 정보 호출
    callDeviceInfo() {
      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callDeviceInfo();
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callDeviceInfo.postMessage('');
        }
      } catch (e) {
        console.log(e);
        //	alert('loginType callDeviceInfo', e);
      }
    },
    //디바이스 정보 가져오기
    async receiveDeviceInfo(json) {
      this.$store.state.json = json;

      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callLayoutSet(json.layoutSet);
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callLayoutSet.postMessage(json.layoutSet);
        }
      } catch (e) {
        console.log(e);
      }

      //현제 web,app 버전 정보 가져오기
      await axios
        .get('http://tab.eghishc.co.kr:7779/ws/api/version/last')
        .then((res) => {
          this.versionItems = res.data.data;
          if (this.versionItems.length < 3) {
            this.$store.state.deviceInfo = true;
          }
        })
        .catch((e) => {
          console.log(e);
        });

      try {
        //디바이스 정보로 얻은것 api 도메인 세팅
        let url = `http://${json.ip}:${json.port}`;
        this.$axios.defaults.baseURL = url;
        this.$store.state.apiDomain = url;
        this.$store.commit('deviceInfo', json);

        //쿠키 값 가져와서 자동 로그인 체크
        this.cookieUserId = Cookies.get('cookieUserId');
        this.cookieAutoLogin = Cookies.get('cookieAutoLogin');
        this.cookieUserPw = Cookies.get('cookieUserPw');

        this.userLoadingFlag = false;

        //업데이트 체크 로직
        try {
          var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

          if (this.versionItems[0].verNo != null) {
            if (varUA.match('android') != null) {
              var dbVersion = this.versionItems[0].verNo;
              var appVersion = this.$store.state.deviceInfo.version;
              if (this.compareVersion(dbVersion, appVersion)) {
                $('.common2_open').click();
                return;
              }
            } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
              var dbVersion = this.versionItems[1].verNo;
              var appVersion = this.$store.state.deviceInfo.version;
              //IOS 일때 처리
              if (this.compareVersion(dbVersion, appVersion)) {
                $('.common2_open').click();
                return;
              }
            }
          }
        } catch (e) {
          alert(e);
        }

        //쿠키 자동로그인 값이 Y일 경우 자동로그인 메소드 호출
        if (this.cookieAutoLogin == 'Y') {
          await this.autoLogin();
        } else {
          this.$router.push({
            name: '로그인'
          });
        }
      } catch (e) {
        //	alert('loginType receiveDeviceInfo', e);
        console.log(e);
      }
    },
    updateStore() {
      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callStore();
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callStore.postMessage('');
        }
      } catch (e) {
        alert(e);
      }
    },
    compareVersion(verA, verB) {
      //a : db b: app
      //같은 경우에는 업데이트 안함
      if (verA == verB) {
        return false;
      }
      var result = false;
      verA = verA.split('.');
      verB = verB.split('.');

      let sumA = verA[0] * 100 + verA[1] * 10 + verA[2] * 1;
      let sumB = verB[0] * 100 + verB[1] * 10 + verB[2] * 1;
      //console.log(`sumA=${sumA} sumB=${sumB}`);
      if (parseInt(sumA) > parseInt(sumB)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    }
  }
};
</script>

<style></style>
